var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGradCapGold1Grey4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8915 1.413L6 0.5L10.1085 1.413C10.2195 1.43768 10.3188 1.49948 10.39 1.5882C10.4612 1.67692 10.5 1.78726 10.5 1.901V6.8945C10.5 7.38837 10.378 7.87459 10.1449 8.31001C9.91188 8.74542 9.57493 9.11657 9.164 9.3905L6 11.5L2.836 9.3905C2.42514 9.11662 2.08823 8.74555 1.85517 8.31023C1.62212 7.8749 1.50012 7.38878 1.5 6.895V1.901C1.50002 1.78726 1.53882 1.67692 1.60999 1.5882C1.68117 1.49948 1.78047 1.43768 1.8915 1.413Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94553 3.00816C5.97337 2.99732 6.00407 2.99728 6.03194 3.00806L9.41991 4.31854C9.52719 4.36004 9.52653 4.51749 9.41891 4.55802L6.03093 5.83386C6.00367 5.84413 5.97377 5.8441 5.94653 5.83378L2.58085 4.55793C2.47355 4.51726 2.47289 4.36028 2.57984 4.31864L5.94553 3.00816Z",
    fill: "#EBDFCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61151 5.4478L6.01951 6.3602L8.31665 5.4478V7.23432C8.31665 7.23432 6.91161 8.006 5.93945 7.99996C4.98564 7.99405 3.61151 7.23432 3.61151 7.23432V5.4478Z",
    fill: "#EBDFCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74775 5.29467L9.13574 5.1543V6.0431C9.22129 6.10407 9.27739 6.2062 9.27739 6.32192C9.27739 6.50868 9.13125 6.66008 8.95098 6.66008C8.77072 6.66008 8.62458 6.50868 8.62458 6.32192C8.62458 6.21281 8.67445 6.11577 8.75187 6.05394H8.74775V5.29467Z",
    fill: "#EBDFCD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradCapGold1Grey4);
export default __webpack_public_path__ + "static/media/gradCap_gold1_grey4.a85ed940.svg";
export { ForwardRef as ReactComponent };